var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0127 2.01948C7.80034 -0.0442526 4.19948 -0.0442526 1.98707 2.01948C-0.224857 4.08365 -0.224857 7.44208 1.98707 9.50626C3.95728 11.3436 7.02578 11.5405 9.23675 10.1057C9.28327 10.3111 9.38974 10.507 9.56096 10.6667L12.7829 13.6722C13.2525 14.1093 14.0112 14.1093 14.4783 13.6722C14.9474 13.2347 14.9474 12.5269 14.4783 12.0907L11.2564 9.08438C11.0861 8.92601 10.8756 8.82625 10.6554 8.78285C12.1945 6.72002 11.9834 3.85818 10.0127 2.01948ZM8.99551 8.55738C7.34376 10.0981 4.65558 10.0981 3.00431 8.55738C1.35352 7.01663 1.35352 4.50955 3.00431 2.9688C4.65558 1.4285 7.34376 1.4285 8.99551 2.9688C10.6473 4.50955 10.6473 7.01663 8.99551 8.55738Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.c0d83141e28604050d1b30551e37cbd2.svg";
export { ForwardRef as ReactComponent };